export default [
  'appSettings',
  'userOrganisations',
];
